module.exports = __webpack_public_path__ + "static/media/katie-bse2_mobile.56c7db06.jpg";